module.exports = __webpack_public_path__ + "img/logoSwapcolor.b992efe8.png";